module.exports = __webpack_public_path__ + "img/icon.fa2de0e0.png";